import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import { isRouteErrorResponse, useRouteError } from "react-router";
import { ErrorScreen } from "@lending/components/ErrorScreen/ErrorScreen";

function ErrorBoundary() {
  const error = useRouteError();

  useEffect(() => {
    // Send error to Sentry
    if (error) {
      if (isRouteErrorResponse(error)) {
        // Handle React Router error responses (404, etc.)
        Sentry.captureException(new Error(`Route Error: ${error.status} ${error.statusText}`), {
          extra: {
            statusText: error.statusText,
            data: error.data,
          },
        });
      } else if (error instanceof Error) {
        // Handle regular JavaScript errors
        Sentry.captureException(error);
      } else {
        // Handle unknown error types
        Sentry.captureException(new Error("Unknown route error"), {
          extra: {
            error: error,
          },
        });
      }
    }
  }, [error]);

  // Log error to console in development
  if (import.meta.env.DEV) {
    console.error("Route error:", error);
  }

  return <ErrorScreen />;
}

export { ErrorBoundary };
